import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import API from './plugins/API'
import BUS from './plugins/BUS'
//import '@mdi/font/css/materialdesignicons.css'

Vue.use(API)
Vue.use(BUS)
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
